import { create } from 'zustand';

export type Toast = { id: string; title: string; body?: string; tone?: 'info' | 'success' | 'error' };

interface NotificationState {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id'>) => void;
  dismiss: (id: string) => void;
}

let seq = 0;

export const useNotificationStore = create<NotificationState>((set, get) => ({
  toasts: [],
  push: (t) => {
    const id = `t-${++seq}`;
    set({ toasts: [...get().toasts, { ...t, id }] });
    window.setTimeout(() => get().dismiss(id), 4500);
  },
  dismiss: (id) =>
    set({ toasts: get().toasts.filter((x) => x.id !== id) }),
}));
